import PropTypes from 'prop-types';
import { path, range, reverse } from 'ramda';
import React, { Component } from 'react';

import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';
import { Field, reduxForm } from 'redux-form';

import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';

import SelectField from '../../components/fields/SelectField';
import SwitchField from '../../components/fields/SwitchField';
import TextField from '../../components/fields/TextField';

import { isAdmin, isSubcontractor, isSubcontractorForVehicle } from '../../modules/selectors/permissions';
import ImageUploadField from '../fields/ImageUploadField';

class BusForm extends Component {
  static propTypes = {
    // state props
    companies: PropTypes.array.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isSubcontractor: PropTypes.bool.isRequired,
    isSubcontractorForVehicle: PropTypes.bool.isRequired,

    // dispatch props
    handleSubmit: PropTypes.func.isRequired,

    // own props
    handleDelete: PropTypes.func.isRequired,
  };

  componentWillMount() {
    const { readEndpoint } = this.props;

    readEndpoint('company?filter[deleted-at__isnull]=True');
  };

  render() {
    const {
      classes,
      error,
      pristine,
      submitting,
      initialValues,
      handleSubmit,
      companies,
      isAdmin,
      isSubcontractor,
      isSubcontractorForVehicle,
      handleDelete,
    } = this.props;
    const years = reverse(range(1980, ((new Date().getFullYear()) + 1)));

    return (
      <form onSubmit={handleSubmit}>
        {error && <Typography variant="subtitle1">{error}</Typography>}

        {(isAdmin || isSubcontractorForVehicle) && initialValues && (
          <Field name="is_active" component={SwitchField} label="Actief" id="bus_form_is_active" />
        )}

        <br />
        <Field name="license_plate" component={TextField} label="Kenteken" fullWidth id="bus_form_license_plate" />

        <Field name="vehicle_number" component={TextField} label="Vlootnummer" fullWidth id="bus_form_vehicle_number" />

        <Field name="year_of_registration" component={SelectField} label="Bouwjaar" fullWidth id="bus_form_year_of_registration">
          {years.map(year => (
            <MenuItem key={year + '-year'} value={year}>{year}</MenuItem>
          ))}
        </Field>

        <Field name="euronorm" component={SelectField} label="Euronorm" fullWidth id="bus_form_euronorm">
          <MenuItem value="euro 0" >Euro 0</MenuItem>
          <MenuItem value="euro 1" >Euro 1</MenuItem>
          <MenuItem value="euro 2" >Euro 2</MenuItem>
          <MenuItem value="euro 3" >Euro 3</MenuItem>
          <MenuItem value="euro 4" >Euro 4</MenuItem>
          <MenuItem value="euro 5" >Euro 5</MenuItem>
          <MenuItem value="euro 5 eev" >EEV</MenuItem>
          <MenuItem value="euro 6" >Euro 6</MenuItem>
        </Field>
        <Field name="seats" component={TextField} label="Aantal stoelen" fullWidth id="bus_form_seats" />
        <Field name="standing_places" component={TextField} label="Aantal staplaatsen" fullWidth id="bus_form_standing_places" />

        <Field
          component={SwitchField}
          id="bus_form_bikes_allowed"
          label="Plek voor fiets"
          labelPlacement="start"
          name="bikes_allowed"
        />

        <br />

        <Field
          component={SwitchField}
          id="bus_form_toilet_available"
          label="Toilet"
          labelPlacement="start"
          name="toilet_available"
        />

        <br />
        <Typography variant="subtitle1" component="b">Bus</Typography>
        <Divider />

        <br />

        <Field name="photo" component={ImageUploadField} label="Bus" />

        <br />

        <Typography variant="subtitle1" component="b">Bedrijf</Typography>
        <Divider />

        <br />

        <Field name="company" component={SelectField} label="Bedrijf" fullWidth id="bus_form_company">
          {companies.map(c => (
            <MenuItem key={c.id} value={c.id}>{path(['attributes', 'name'], c) || 'Onbekend'}</MenuItem>
          ))}
        </Field>

        <br />

        <CardActions className={classes.cardActions}>
          {(isAdmin || isSubcontractor) && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDelete()}
            >
              Verwijderen bus
            </Button>
          )}
          {(isAdmin || isSubcontractor) && (
            <Button
              disabled={pristine || submitting}
              variant="contained"
              color="primary"
              type="submit"
            >
              {initialValues ? 'Wijzig bus' : 'Voeg bus toe'}
            </Button>
          )}
        </CardActions>
      </form>
    );
  };
}

const mapStateToProps = (state, props) => ({
  companies: state.api.company && state.api.company.data || [],
  isAdmin: isAdmin(state),
  isSubcontractor: isSubcontractor(state),
  isSubcontractorForVehicle: isSubcontractorForVehicle(state, props),
});

const mapDispatchToProps = {
  readEndpoint,
};

BusForm = reduxForm({
  form: 'busForm',
  validate: (values) => {
    const errors = {};

    if (!values.license_plate) errors.license_plate = 'Verplicht (voorbeeld: BP-NN-74)';
    if (!values.vehicle_number) errors.vehicle_number = 'Verplicht (voorbeeld: 7153)';
    if (!values.year_of_registration) errors.year_of_registration = 'Verplicht (voorbeeld: 2004)';
    if (!values.euronorm) errors.euronorm = 'Verplicht (voorbeeld: Euro 3)';
    if (!values.seats) errors.seats = 'Verplicht (voorbeeld: 42)';
    if (!values.standing_places && values.standing_places !== 0) errors.standing_places = 'Verplicht (voorbeeld: 12)';

    if (!values.company) errors.company = 'Verplicht (kies een bedrijf uit de lijst)';

    return errors;
  },
})(BusForm);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles({
  cardActions: {
    justifyContent: 'flex-end',
    marginTop: 20,
  },
})(BusForm));
